import React from "react";
import { ExternalLink, BadgeCheck } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { citations, clinic } from "../data/mock";

const MedicalCitations = () => {
  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="container-app">
        <SectionHeading eyebrow="Verified & Listed On" title="Medical Citations & Trusted Directories"
          subtitle={`${clinic.doctorName} is a verified, listed specialist across India's leading healthcare platforms.`} />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {citations.map((c, i) => (
            <a key={i} href={c.url} target="_blank" rel="noopener noreferrer"
              className="group flex items-center justify-between gap-2 bg-white border border-slate-200 rounded-xl px-4 py-4 shadow-sm hover:shadow-md hover:border-sky-300 transition-all">
              <span className="flex items-center gap-2.5 min-w-0">
                <BadgeCheck size={18} className="text-sky-500 shrink-0" />
                <span className="text-sm font-semibold text-slate-700 group-hover:text-sky-600 truncate">{c.name}</span>
              </span>
              <ExternalLink size={15} className="text-slate-400 group-hover:text-sky-500 shrink-0 transition-colors" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MedicalCitations;
